'use client';

import { Button } from '@/components/ui/Button';
import { Modal } from '@/components/ui/Modal';
import { useTranslations } from 'next-intl';

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  error: string;
  title?: string;
  showRetryButton?: boolean;
  onRetry?: () => void;
}

export function ErrorModal({
  isOpen,
  onClose,
  error,
  title,
  showRetryButton = true,
  onRetry,
}: ErrorModalProps) {
  const t = useTranslations('ErrorModal');

  const handleRetry = () => {
    onRetry?.();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className='backdrop-blur-sm'
      contentClassName='p-6'
    >
      {title && (
        <div className='mb-4 flex items-center justify-between'>
          <h3 className='text-lg font-semibold text-gray-900'>{title}</h3>
        </div>
      )}
      {/* Error Message */}
      <div className='mb-6 rounded-md bg-red-100 p-4'>
        <p className='sh-body text-red-700'>{error}</p>
      </div>

      {/* Actions */}
      <div className='flex justify-end space-x-3'>
        <Button variant='ghost' onClick={onClose}>
          {t('cancelButton')}
        </Button>
        {showRetryButton && (
          <Button variant='dark' onClick={handleRetry}>
            {t('tryAgainButton')}
          </Button>
        )}
      </div>
    </Modal>
  );
}
